// Личный кабинет резидента — интерфейс.
// Все потоки — настоящие <form data-ajax data-mid>; сабмит собирает поля через FormData(form).
// Рендер — на сервере (XSL); JS только валидирует, подставляет HTML-фрагменты и управляет UI.

var RU2LAT = { 'А':'A','В':'B','Е':'E','К':'K','М':'M','Н':'H','О':'O','Р':'P','С':'C','Т':'T','У':'Y','Х':'X' };

var curFilter = 'all';

/* ---------- утилиты ---------- */
function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
function el(id) { return document.getElementById(id); }
function val(id) { var e = el(id); return e ? e.value : ''; }
function setText(id, t) { var e = el(id); if (e) e.textContent = t; }
function showErr(id, on) { var e = el(id); if (e) e.classList.toggle('show', !!on); }
function esc(s) {
	s = String(s == null ? '' : s);
	return s.replace(/[&<>"]/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; });
}
function pad(n) { return n < 10 ? '0' + n : '' + n; }
function isoDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
function isoToday() { return isoDate(new Date()); }
function isoPlus(days, years) { var d = new Date(); if (days) d.setDate(d.getDate() + days); if (years) d.setFullYear(d.getFullYear() + years); return isoDate(d); }

/* ошибки в рамках формы (по data-err) */
function clearFormErrors(form) {
	each(form.querySelectorAll('.err-msg'), function (e) { e.classList.remove('show'); });
	each(form.querySelectorAll('.input.err'), function (e) { e.classList.remove('err'); });
}
function fieldErr(form, key, text) {
	var e = form.querySelector('[data-err="' + key + '"]');
	if (e) { if (text) e.textContent = text; e.classList.add('show'); }
}

function toast(msg, type) {
	var w = el('toastWrap');
	if (!w) { return; }
	var t = document.createElement('div');
	t.className = 'toast' + (type === 'err' ? ' err' : '');
	t.innerHTML = '<span class="dot"></span>' + esc(msg);
	w.appendChild(t);
	setTimeout(function () {
		t.style.opacity = '0'; t.style.transition = 'opacity .3s';
		setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
	}, 2600);
}

/* ---------- отправка форм ---------- */
function onSubmit(form) {
	// ВАЖНО: form.id затеняется скрытым полем <input name="id">, поэтому берём атрибут явно
	var fid = form.getAttribute('id');
	if ((fid === 'carForm' || fid === 'phForm') && !validateCreate(form)) return;
	if (fid === 'modalForm' && !validateModal(form)) return;

	fetch('/ajax.php?mid=' + form.getAttribute('data-mid'), { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
		.then(function (r) { return r.json(); })
		.then(
			function (res) { onResult(form, res); },
			function () { toast('Сетевая ошибка, попробуйте ещё раз', 'err'); }
		);
}

function onResult(form, res) {
	switch (form.getAttribute('id')) {
		case 'lgForm':
			if (res.success) location.reload();
			else showErr('lgErr', true);
			break;
		case 'fpForm':
			toast(res.msg || 'Если адрес зарегистрирован, на него отправлен временный пароль.');
			if (el('forgotBox')) el('forgotBox').style.display = 'none';
			break;
		case 'logoutForm':
			location.href = '/';
			break;
		case 'carForm':
		case 'phForm':
			if (res.success) {
				setListHtml(res.html);
				form.reset();
				updateFormToggles(form);
				toast('Пропуск выдан и отправлен на КПП');
				switchTab('list');
			} else {
				showCreateError(form, res.error);
			}
			break;
		case 'modalForm':
			if (res.success) {
				setListHtml(res.html);
				closeModal();
				toast(form.querySelector('[name="action"]').value === 'delete' ? 'Пропуск удалён' : 'Срок пропуска продлён');
			} else if (res.error === 'bad_range') {
				fieldErr(form, 'modal', 'Не более 1 года от даты начала.');
			} else if (res.error === 'auth') {
				toast('Сессия истекла, войдите снова', 'err'); setTimeout(function () { location.reload(); }, 1300);
			} else {
				toast('Не удалось выполнить операцию', 'err');
			}
			break;
	}
}

/* ---------- валидация создания ---------- */
function validateCreate(form) {
	clearFormErrors(form);
	var ok = true;
	var subj = form.querySelector('input[name="subj"]:checked');
	subj = subj ? subj.value : 'employee';
	var contractor = form.querySelector('[name="contractor"]');
	var fio = form.querySelector('[name="fio"]');
	var consent = form.querySelector('[name="consent"]');
	var value = form.querySelector('[name="value"]');
	var term = form.querySelector('input[name="term"]:checked');
	term = term ? term.value : 'once';

	if (subj === 'contractor' && (!contractor || !contractor.value.trim())) { fieldErr(form, 'contractor'); ok = false; }
	if (!fio || !fio.value.trim()) { fieldErr(form, 'fio'); ok = false; }

	if (form.getAttribute('id') === 'phForm') {
		var digits = phoneDigits(value.value);
		if (digits.length !== 10) { fieldErr(form, 'value', 'Введите 10 цифр номера.'); value.classList.add('err'); ok = false; }
	} else {
		if (!value || value.value.trim().length < 4) { fieldErr(form, 'value', 'Введите корректный номер: латинские буквы и цифры.'); value.classList.add('err'); ok = false; }
	}

	if (!consent || !consent.checked) { fieldErr(form, 'consent'); ok = false; }

	if (term === 'manual') {
		var f = form.querySelector('[name="from"]'), t = form.querySelector('[name="to"]');
		var dF = new Date(f.value), dT = new Date(t.value), mx = new Date(f.value); mx.setFullYear(mx.getFullYear() + 1);
		if (!f.value || !t.value || dT <= dF || dT > mx) { fieldErr(form, 'range'); ok = false; }
	}

	if (!ok) toast('Проверьте поля формы', 'err');
	return ok;
}

function showCreateError(form, err) {
	var isCar = form.getAttribute('id') === 'carForm';
	if (err === 'duplicate') fieldErr(form, 'value', isCar ? 'Такой номер уже есть среди действующих пропусков.' : 'Такой телефон уже есть среди действующих пропусков.');
	else if (err === 'consent_required') fieldErr(form, 'consent');
	else if (err === 'contractor_required') fieldErr(form, 'contractor');
	else if (err === 'fio_required') fieldErr(form, 'fio');
	else if (err === 'bad_range') fieldErr(form, 'range');
	else if (err === 'bad_plate') fieldErr(form, 'value', 'Введите корректный номер.');
	else if (err === 'bad_phone') fieldErr(form, 'value', 'Введите 10 цифр номера.');
	else if (err === 'auth') { toast('Сессия истекла, войдите снова', 'err'); setTimeout(function () { location.reload(); }, 1300); }
	else toast('Не удалось оформить пропуск', 'err');
}

function validateModal(form) {
	if (form.querySelector('[name="action"]').value !== 'renew') return true;  // удаление — без даты
	clearFormErrors(form);
	var inp = el('modalDate');
	var from = form.getAttribute('data-from');
	var nt = inp.value;
	var dF = from ? new Date(from) : new Date(), dT = new Date(nt), mx = new Date(dF); mx.setFullYear(mx.getFullYear() + 1);
	if (!nt || dT <= dF || dT > mx) { fieldErr(form, 'modal', 'Не более 1 года от даты начала.'); return false; }
	return true;
}

/* ---------- вкладки / переключатели форм ---------- */
function switchTab(t) {
	each(document.querySelectorAll('.tab'), function (b) { b.classList.toggle('active', b.getAttribute('data-tab') === t); });
	each(document.querySelectorAll('.panel'), function (p) { p.classList.remove('active'); });
	var panel = el('panel-' + t);
	if (panel) panel.classList.add('active');
	if (t === 'list') applyFilter();
}
function updateFormToggles(form) {
	var subj = form.querySelector('input[name="subj"]:checked');
	var conField = form.querySelector('[data-role="contractor"]');
	if (conField) conField.style.display = (subj && subj.value === 'contractor') ? 'block' : 'none';

	var term = form.querySelector('input[name="term"]:checked');
	var manual = form.querySelector('[data-role="manual"]');
	if (manual) {
		var isManual = term && term.value === 'manual';
		manual.classList.toggle('show', isManual);
		if (isManual) {
			var f = form.querySelector('[name="from"]'), t = form.querySelector('[name="to"]');
			if (f && !f.value) { f.value = isoToday(); f.min = isoToday(); }
			if (t && !t.value) { t.value = isoPlus(1, 0); }
			if (t) t.max = isoPlus(0, 1);
		}
	}
}
function onPlate(e) {
	var v = e.value.toUpperCase();
	v = v.replace(/[А-ЯЁ]/g, function (ch) { return RU2LAT[ch] || ''; });
	v = v.replace(/[^A-Z0-9]/g, '');
	e.value = v; e.classList.remove('err');
}
/* 10 цифр номера без кода страны. +7 / 8 из телефонной книги отбрасываем:
   префикс +7 уже стоит рядом с полем, иначе номер съезжает на одну цифру. */
function phoneDigits(raw) {
	var s = String(raw || '').trim();
	var d = s.replace(/\D/g, '');
	// «+7…» из телефонной книги или 11 цифр с 8/7 — это код страны, не часть номера
	if ((s.charAt(0) === '+' || d.length > 10) && (d.charAt(0) === '7' || d.charAt(0) === '8'))
		d = d.slice(1);
	return d.slice(0, 10);
}
function onPhone(e) {
	var d = phoneDigits(e.value), out = '';
	if (d.length > 0) out = '(' + d.slice(0, 3);
	if (d.length >= 3) out += ') ' + d.slice(3, 6);
	// Тире только вместе со следующей цифрой, иначе после стирания хвоста оно остаётся.
	if (d.length > 6) out += '-' + d.slice(6, 8);
	if (d.length > 8) out += '-' + d.slice(8, 10);
	e.value = out; e.classList.remove('err');
}

/* ---------- список ---------- */
function setListHtml(html) {
	var box = el('lk-list');
	if (box) box.innerHTML = html;
	applyFilter();
	updateCount();
}
function updateCount() {
	var c = el('tabCount');
	if (c) c.textContent = document.querySelectorAll('#cardsBody .pcard').length;
}
function setFilter(f) {
	curFilter = f;
	each(document.querySelectorAll('.filter-chip'), function (c) { c.classList.toggle('active', c.getAttribute('data-f') === f); });
	applyFilter();
}
function applyFilter() {
	var q = (val('searchBox') || '').toLowerCase().trim();
	each(document.querySelectorAll('#lk-list [data-pass]'), function (e) {
		var kind = e.getAttribute('data-kind'), status = e.getAttribute('data-status'), search = e.getAttribute('data-search') || '';
		var show = true;
		if (curFilter === 'car' && kind !== 'car') show = false;
		if (curFilter === 'phone' && kind !== 'phone') show = false;
		if (curFilter === 'active' && status === 'dead') show = false;
		if (show && q && search.indexOf(q) === -1) show = false;
		e.style.display = show ? '' : 'none';
	});
	var visible = 0;
	each(document.querySelectorAll('#cardsBody .pcard'), function (e) { if (e.style.display !== 'none') visible++; });
	if (el('lkEmpty')) el('lkEmpty').style.display = visible === 0 ? '' : 'none';
}

/* ---------- модалка (продление / удаление) ---------- */
function openModal() { var m = el('modalBg'); if (m) m.classList.add('show'); }
function closeModal() { var m = el('modalBg'); if (m) m.classList.remove('show'); }

function openExtend(btn) {
	var form = el('modalForm');
	var from = btn.getAttribute('data-from'), to = btn.getAttribute('data-to');
	form.querySelector('[name="action"]').value = 'renew';
	form.querySelector('[name="id"]').value = btn.getAttribute('data-id');
	form.querySelector('[name="kind"]').value = btn.getAttribute('data-kind');
	form.setAttribute('data-from', from || '');
	setText('modalTitle', 'Продлить пропуск');
	el('modalText').innerHTML = '<b>' + esc(btn.getAttribute('data-fio')) + '</b> · <span class="val-mono">' + esc(btn.getAttribute('data-value')) + '</span>';
	el('modalDateField').style.display = 'block';
	var inp = el('modalDate');
	inp.value = to || '';
	inp.min = isoToday();
	var base = from ? new Date(from) : new Date(); var mx = new Date(base); mx.setFullYear(mx.getFullYear() + 1);
	inp.max = isoDate(mx);
	clearFormErrors(form);
	setText('modalOk', 'Продлить');
	openModal();
}
function openDelete(btn) {
	var form = el('modalForm');
	form.querySelector('[name="action"]').value = 'delete';
	form.querySelector('[name="id"]').value = btn.getAttribute('data-id');
	form.querySelector('[name="kind"]').value = btn.getAttribute('data-kind');
	setText('modalTitle', 'Удалить пропуск?');
	el('modalText').innerHTML = 'Пропуск <b>' + esc(btn.getAttribute('data-fio')) + '</b> · <span class="val-mono">' + esc(btn.getAttribute('data-value')) + '</span> будет отозван на КПП. Действие необратимо.';
	el('modalDateField').style.display = 'none';
	clearFormErrors(form);
	setText('modalOk', 'Удалить');
	openModal();
}

/* ---------- история ---------- */
function loadMore(btn) {
	var page = parseInt(btn.getAttribute('data-page'), 10) || 1;
	btn.disabled = true;
	fetch('/ajax.php?mid=8', { method: 'POST', body: formData({ action: 'history', page: page }), credentials: 'same-origin' })
		.then(function (r) { return r.json(); })
		.then(function (res) {
			btn.disabled = false;
			if (!res.success) return;
			if (el('logBody')) el('logBody').insertAdjacentHTML('beforeend', res.html);
			if (res.hasmore === '1' || res.hasmore === 1) btn.setAttribute('data-page', page + 1);
			else btn.style.display = 'none';
		})
		.catch(function () { btn.disabled = false; });
}
function formData(obj) { var fd = new FormData(); for (var k in obj) fd.append(k, obj[k]); return fd; }

/* ---------- делегирование ---------- */
function init() {
	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (form && form.matches && form.matches('form[data-ajax]')) { e.preventDefault(); onSubmit(form); }
	});

	document.addEventListener('click', function (e) {
		if (e.target.id === 'modalBg') { closeModal(); return; }
		var chip = e.target.closest && e.target.closest('.filter-chip');
		if (chip) { setFilter(chip.getAttribute('data-f')); return; }
		var tab = e.target.closest && e.target.closest('.tab');
		if (tab) { switchTab(tab.getAttribute('data-tab')); return; }
		var node = e.target.closest && e.target.closest('[data-act]');
		if (!node) return;
		switch (node.getAttribute('data-act')) {
			case 'forgot-toggle': {
				var b = el('forgotBox');
				if (b) b.style.display = (b.style.display === 'none' || !b.style.display) ? 'block' : 'none';
				showErr('fpErr', false);
				break;
			}
			case 'renew': openExtend(node); break;
			case 'delete': openDelete(node); break;
			case 'modal-cancel': closeModal(); break;
			case 'log-more': loadMore(node); break;
		}
	});

	document.addEventListener('change', function (e) {
		if (e.target.name === 'subj' || e.target.name === 'term') {
			var form = e.target.closest('form');
			if (form) updateFormToggles(form);
		}
	});

	document.addEventListener('input', function (e) {
		if (e.target.id === 'carPlate') onPlate(e.target);
		else if (e.target.id === 'phPhone') onPhone(e.target);
		else if (e.target.id === 'searchBox') applyFilter();
	});

	if (el('lk-list')) { updateCount(); applyFilter(); }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
